import { InputHTMLAttributes } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { Checkbox } from '@flipster/react/design-system/checkbox';
import { vstack } from '@flipster/styled-system/patterns';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  name: string;
  items: { label: string; value: string }[];
}

export const CheckBoxGroup = ({ name, items, ...inputProps }: Props) => {
  const { register, control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  return (
    <fieldset className={vstack({ gap: 8, alignItems: 'flex-start' })}>
      {items?.map((item) => (
        <Checkbox
          key={item.value}
          {...register(name)}
          value={item.value}
          css={{
            textStyle: 'Text/M/Regular',
            color: 'content.default.level-3',
          }}
          checked={value?.includes(item.value)}
          onChange={(e) => {
            const isChecked = e.target.checked;
            const newValue = isChecked ? [...value, item.value] : value.filter((v: string) => v !== item.value);
            onChange(newValue);
          }}
          {...inputProps}
        >
          {item.label}
        </Checkbox>
      ))}
    </fieldset>
  );
};
